module.exports = __webpack_public_path__ + "icon-96x96.png";